const normalizeOverviewText = (value: string) => value.replace(/\s+/g, ' ').trim();

export const getDistinctOverviewContent = (description: string, content: string) => {
  const normalizedDescription = normalizeOverviewText(description);
  const normalizedContent = normalizeOverviewText(content);

  return normalizedContent && normalizedContent !== normalizedDescription ? content : '';
};
